/**
 * 时间轴调试：URL ?debug=1 或 ?timeline_debug=1
 * 或控制台：localStorage.setItem('tyq_timeline_debug','1') 后刷新
 */
const LS_KEY = 'tyq_timeline_debug';

export function isTimelineDebug() {
  if (typeof window === 'undefined') return false;
  try {
    if (window.localStorage?.getItem(LS_KEY) === '1') return true;
  } catch (e) { /* ignore */ }
  const q = new URLSearchParams(window.location.search);
  return q.get('debug') === '1' || q.get('timeline_debug') === '1';
}

export function timelineDebug(tag, payload) {
  if (!isTimelineDebug()) return;
  const t = new Date().toISOString().slice(11, 23);
  console.log(`[tyq时间轴 ${t}] ${tag}`, payload);
}

export function printTimelineDebugHint() {
  if (typeof window === 'undefined') return;
  if (isTimelineDebug()) {
    console.info('[tyq] 时间轴调试已开启 (?debug=1 / localStorage.tyq_timeline_debug=1)');
    return;
  }
  console.info('[tyq] 时间轴调试：URL 加 ?debug=1 或执行 localStorage.setItem("tyq_timeline_debug","1") 后刷新');
}
